import { useUser } from "@faire/retailer-visitor-shared/hooks/user/useUser";

export const useUserPersonalInfo = () => {
  const { user } = useUser();
  return {
    fullName: user ? `${user.first_name} ${user.last_name}`.trim() : "",
    firstName: user?.first_name ?? "",
    lastName: user?.last_name ?? "",
    emailAddress: user?.email_address,
    phoneNumber: user?.phone_number,
    userToken: user?.token ?? "",
  };
};
